/* eslint-disable import/no-cycle */
import CardIconDescriptionColumnsComponent from 'components/CardIconDescriptionColumns';
import { logger } from '../../utils';
import { CType } from '../../models/Contentful/types';
import { ICardIconDescriptionColumnsBladeProps } from './@types';

const CardIconDescriptionColumnsBlade: React.FC<
  CType<ICardIconDescriptionColumnsBladeProps>
> = props => {
  try {
    const { fields } = props;
    return <CardIconDescriptionColumnsComponent {...fields} />;
  } catch (error) {
    logger.error(error);
    return null;
  }
};
export default CardIconDescriptionColumnsBlade;
